import Notification from "./notification";
import Recipient from "../workflow/recipient";
import Guid from "~/helpers/guid";
import Vue from "vue";
import {RecipientType} from "../../../../common/enums/recipentType";

export default class RecipientFactory {
  static create(notification: Notification, isAttached: boolean = false, recipientType: RecipientType = RecipientType.to) {
    const recipient = new Recipient();

    recipient.rootModel = notification.rootModel;
    recipient.parent = notification;
    recipient.defineProperty('client_id', Guid.create());
    recipient.defineProperty('reference_id', null);
    recipient.defineProperty('reference_type', null);
    recipient.defineProperty('recipient_type', recipientType);

    if (isAttached) {
      Recipient.repo.add(recipient);
      Vue.set(notification.recipients, recipient.client_id, recipient);
    }

    return recipient;
  }
}